<template>
  <div class="navbar-priadi">
    <button class="navbar-priadi-btn" @click="goBack()" aria-label="Go back">
      <i class="bi-arrow-left"></i>
    </button>
    <span class="navbar-priadi-title">{{ title }}</span>
    <div class="navbar-priadi-btn navbar-spacer" aria-hidden="true"></div>
  </div>
</template>

<script>
export default {
  name: "Navigation",
  props: {
    title: String,
    goto: {
      default: '',
      type: String
    },
    numback: {
      default: '',
      type: String
    }
  },
  methods: {
    goBack() {
      if (this.goto) {
        this.$router.push(this.goto)
      } else if (this.numback) {
        this.$router.go(this.numback)
      } else {
        this.$router.back()
      }
    }
  }
}
</script>

<style scoped>
</style>
